import { toggleImageTileExpansion } from './toggle-image-tile-expansion';
import { trackDimensionExpansion } from './track-dimension-expansion';

export const setupMoreColorsLink = (showMoreColorsLink: HTMLElement, imageTileContainer: HTMLElement, productId: string) => {
    showMoreColorsLink.classList.remove('pl_hidden');
    showMoreColorsLink.onclick = () => {
        trackDimensionExpansion(showMoreColorsLink);
        toggleImageTileExpansion(showMoreColorsLink, imageTileContainer, productId);
    };
};
